exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat+Alternates:300,400,500,600,700|Montserrat:300,400,500,600,700|Raleway:300,400,500,600,700&display=swap);", ""]);

// module
exports.push([module.id, "footer[data-v-287deba8]{height:80px;padding-top:1rem;padding-bottom:1rem;background:#262626}footer p[data-v-287deba8]{color:#9a9899;margin-bottom:0;font-size:.7rem}@media (min-width:576px){footer p[data-v-287deba8]{font-size:.8rem}}footer p span[data-v-287deba8]{display:block}@media (min-width:576px){footer p span[data-v-287deba8]{display:inline-block}}footer p span a[data-v-287deba8]{color:#9a9899}footer p span a[data-v-287deba8]:hover{text-decoration:none;color:#ff6651!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-287deba8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 373
// module chunks = 0